import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidTextSurround",
  "use": "SolidTextSurround-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"SolidTextSurround\"><path d=\"M9 6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-.5H6.221l-.272.816a1.001 1.001 0 0 1-1.897-.632l2-6A.999.999 0 0 1 7 6h2zM8 8h-.279l-.833 2.5H8V8zm11 8H5a1 1 0 0 0 0 2h14a1 1 0 0 0 .117-1.993L19 16zm0-5h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 .117-1.993L19 11zm-7-4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-.993-.883L12 7z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol